module.exports = __webpack_public_path__ + "static/media/hall-C11-12r90-2026.3c0e6746.svg";